module.exports = __webpack_public_path__ + "static/media/Definitely.6c58be29.png";